import { makeRequest } from 'utils/requestLogger';

export default (participationID, payload) =>
  makeRequest(
    'put',
    `/api/participations/${participationID}/assessments`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/updateParticipantAssessment.js